/* Copyright (c) 2018 Scaper */

import * as cx from "classnames";
import * as React from "react";
import { connect } from "react-redux";
import { RouteComponentProps, withRouter } from "react-router";
import { IPlace } from "../../functions/src/api/placeInterface";
import { IApi } from "../api/api";
import { AppPath, IAppRouteParams } from "../paths/pathIndex";
import { PlaceInput } from "../place/placeInput";
import { PlaceMap } from "../place/placeMap";
import { IAppState } from "./appState";
import { EstimateDetails } from "../estimate/estimateDetails";
import { RequirePhoneVerifiedOrPrompt } from "./auth/requirePhoneVerifiedOrPrompt";
import { RequireSignedInOrPrompt } from "./auth/requireSignedInOrPrompt";

import "./appHome.scss";

interface IOwnProps {
    api: IApi;
    routeParams: IAppRouteParams;
}

interface IStateProps {
    place: IPlace | "LOADING" | undefined;
}

type IProps = IOwnProps & IStateProps;

class UnconnectedAppHome extends React.PureComponent<IProps & RouteComponentProps<any>, {}> {
    public render() {
        const { place } = this.props;
        const defaultValue = place != null && place != "LOADING" ? place.formatted_address : undefined;
        return (
            <>
                <div className="scpr-AppHome-header z-depth-2">
                    <div className="container">
                        <div className="scpr-AppHome-header-title">Scaper</div>
                    </div>
                </div>

                <div className={cx("scpr-AppHome-body", { "scpr-AppHome-body-bottom-open": place != null })}>
                    <div className="scpr-AppHome-body-top">
                        <div className="container">
                            <div className="scpr-AppHome-place-input-card card-panel">
                                <PlaceInput defaultValue={defaultValue} onPlaceChanged={this.handlePlaceChanged} />
                            </div>
                        </div>

                        <div className="scpr-AppHome-map-container">
                            <div className="scpr-AppHome-map z-depth-1">
                                <PlaceMap place={place} />
                            </div>
                        </div>
                    </div>

                    <div className="scpr-AppHome-body-bottom">
                        <div className="scpr-AppHome-bottom-card z-depth-1">
                            <div className="container">
                                {this.renderEstimate()}

                                {this.renderPaymentInfo()}

                                {this.renderSubmitButton()}
                            </div>
                        </div>
                    </div>
                </div>
            </>
        );
    }

    public componentDidMount() {
        const { api, routeParams } = this.props;
        const { placeId } = routeParams;
        if (placeId != null) {
            api.placeService.ensurePlaceIsLoaded(placeId);
        }
    }

    public componentDidUpdate(prevProps: IProps) {
        const { api, routeParams } = this.props;
        const { placeId } = routeParams;
        const { placeId: prevPlaceId } = prevProps.routeParams;
        if (placeId != null && placeId !== prevPlaceId) {
            api.placeService.ensurePlaceIsLoaded(placeId);
        }
    }

    private renderEstimate() {
        const { api, place } = this.props;
        return (
            <div className="row scpr-AppHome-estimate-details-row">
                <div className="col s12 m10 offset-m1">
                    <EstimateDetails api={api} place={place} />
                </div>
            </div>
        );
    }

    private renderPaymentInfo() {
        const { api } = this.props;
        const buttonClasses = "col s12 m8 offset-m2 l6 offset-l3";
        return (
            <div className="row scpr-AppHome-payment-info-row">
                <RequireSignedInOrPrompt api={api}>
                    {(userInfo) => (
                        <RequirePhoneVerifiedOrPrompt api={api} className={buttonClasses} userInfo={userInfo}>
                            {() => (
                                <div className={buttonClasses}>{userInfo.displayName}</div>
                            )}
                        </RequirePhoneVerifiedOrPrompt>
                    )}
                </RequireSignedInOrPrompt>
            </div>
        );
    }

    private renderSubmitButton() {
        const disabled = true;
        return (
            <div className="row scpr-AppHome-submit-button-row">
                <button
                    className={cx("btn-large waves-effect waves-light col s12 m8 offset-m2 l6 offset-l3", { disabled })}
                    type="submit"
                >
                    Order Now
                    <i className="material-icons right">send</i>
                </button>
            </div>
        )
    }

    private handlePlaceChanged = (place: IPlace | undefined) => {
        const { api, history, routeParams } = this.props;
        const { placeId: currentPlaceId } = routeParams;

        if (place == null) {
            if (currentPlaceId != null) {
                const path = AppPath.of({});
                history.replace(path);
            }
        } else {
            api.placeService.setPlace(place);

            const { place_id } = place;
            const path = AppPath.of({ placeId: place_id });
            history.replace(path);
        }
    };
}

function mapStateToProps(state: IAppState, ownProps: IOwnProps): IStateProps {
    const { routeParams } = ownProps;
    const { placeId } = routeParams;
    const { places } = state.place;
    const place = placeId != null ? places[placeId] : undefined;
    return { place };
}

export const AppHome = withRouter(connect<IStateProps, {}, IOwnProps, IAppState>(mapStateToProps)(UnconnectedAppHome));
